import * as Sentry from "@sentry/browser";
import initErrorLogger from "./common/initErrorLogger";

initErrorLogger({ sentry: Sentry, breadCrumbs: true });
